import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { Logo } from '../../components/Logo/Logo';
import { apiService } from '../../services/api';
import './ResetPassword.css';

export const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (senha.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres');
      return;
    }
    if (senha !== confirmarSenha) {
      setError('As senhas não coincidem');
      return;
    }
    if (!token) {
      setError('Link inválido. Solicite um novo link de redefinição.');
      return;
    }

    setLoading(true);
    try {
      await apiService.resetPassword(token, senha);
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Erro ao redefinir senha. O link pode ter expirado.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="reset-password-container">
        <div className="reset-password-box">
          <div className="reset-password-logo">
            <Logo size="large" />
          </div>
          <h2 className="reset-password-title">Link inválido</h2>
          <p className="reset-password-error-text">
            Este link de redefinição não é válido ou expirou. Solicite um novo em &quot;Esqueci minha senha&quot;.
          </p>
          <Link to="/forgot-password" className="reset-password-link">Solicitar novo link</Link>
          <Link to="/login" className="reset-password-back">Voltar ao login</Link>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="reset-password-container">
        <div className="reset-password-box">
          <div className="reset-password-logo">
            <Logo size="large" />
          </div>
          <h2 className="reset-password-title">Senha alterada</h2>
          <p className="reset-password-success-text">
            Sua senha foi alterada com sucesso. Redirecionando para o login...
          </p>
          <Link to="/login" className="reset-password-link">Ir para o login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="reset-password-container">
      <div className="reset-password-box">
        <div className="reset-password-logo">
          <Logo size="large" />
        </div>
        <h2 className="reset-password-title">Nova senha</h2>
        <p className="reset-password-subtitle">
          Digite e confirme sua nova senha.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="senha">Nova senha</label>
            <input
              type="password"
              id="senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
              minLength={6}
              placeholder="Mínimo 6 caracteres"
              autoFocus
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirmarSenha">Confirmar senha</label>
            <input
              type="password"
              id="confirmarSenha"
              value={confirmarSenha}
              onChange={(e) => setConfirmarSenha(e.target.value)}
              required
              minLength={6}
              placeholder="Repita a senha"
            />
          </div>

          {error && <div className="reset-password-error">{error}</div>}

          <button type="submit" disabled={loading} className="reset-password-button">
            {loading ? 'Salvando...' : 'Redefinir senha'}
          </button>
        </form>

        <div className="reset-password-info">
          <Link to="/login">Voltar ao login</Link>
        </div>
      </div>
    </div>
  );
};
